import { Component } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { FieldConfig } from '@smartflip/data-models';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'lib-check-box',
  templateUrl: './check-box.component.html',
  styleUrls: ['./check-box.component.scss'],
  imports: [ReactiveFormsModule, IonicModule],
})
export class CheckBoxComponent {
  field: FieldConfig;
  group: UntypedFormGroup;
}
